import React from "react";
import cn from "classnames";
import styles from "./PlatformPart.module.css";

import Button from "./Button";

import BuzzerRed from "../../images/buzzer-full-red.png";
import BuzzerYellow from "../../images/buzzer-full-yellow.png";
import BuzzerBlue from "../../images/buzzer-full-blue.png";
import BuzzerRedPressed from "../../images/buzzer-pressed-red.png";
import BuzzerYellowPressed from "../../images/buzzer-pressed-yellow.png";
import BuzzerBluePressed from "../../images/buzzer-pressed-blue.png";

function PlatformPart({
  image,
  imageAlt,
  customStyles,
  buttonKeys = [],
  keysPressed,
}) {
  return (
    <>
      <div className={cn(styles.platformPart, customStyles)}>
        <img src={image} alt={imageAlt} />
        <div className={styles.buttonsWrapper}>
          {buttonKeys[0] && buttonKeys[1] && buttonKeys[2] && (
            <>
              <Button
                imageButtonFull={BuzzerBlue}
                imageButtonPressed={BuzzerBluePressed}
                keyName={buttonKeys[0]}
                isPressed={keysPressed.includes(buttonKeys[0])}
              />
              <Button
                imageButtonFull={BuzzerYellow}
                imageButtonPressed={BuzzerYellowPressed}
                keyName={buttonKeys[1]}
                isPressed={keysPressed.includes(buttonKeys[1])}
              />
              <Button
                imageButtonFull={BuzzerRed}
                imageButtonPressed={BuzzerRedPressed}
                keyName={buttonKeys[2]}
                isPressed={keysPressed.includes(buttonKeys[2])}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default PlatformPart;
